import { CheckCircleIcon } from "@heroicons/react/24/outline";
import { AnimatePresence, motion } from "framer-motion";
import React from "react";
import { Link } from "react-router-dom";
import { contactPath } from "./agenda-actions";
import { AgendaCompletedTouchpoint } from "./marketing-plan-agenda";
import { describeChannels } from "./marketing-plan-format";

interface AgendaRecentlyCompletedProps {
    items: AgendaCompletedTouchpoint[];
}

export const AgendaRecentlyCompleted: React.FC<AgendaRecentlyCompletedProps> = ({
    items,
}) => {
    if (items.length === 0) {
        return null;
    }

    return (
        <div className="overflow-hidden rounded-lg bg-white ring-1 ring-gray-300">
            <div className="flex items-center gap-2 border-b border-gray-200 px-4 py-3">
                <span className="h-5 w-1 flex-shrink-0 rounded-full bg-green-500" />
                <CheckCircleIcon className="h-4 w-4 flex-shrink-0 text-green-600" />
                <span className="text-sm font-semibold text-gray-800">
                    Recently completed
                </span>
                <span className="text-xs text-gray-500">{items.length}</span>
            </div>
            <ul className="divide-y divide-gray-100">
                <AnimatePresence initial={false}>
                    {items.map(item => (
                        <motion.li
                            key={item.touchpointId}
                            layout
                            initial={{ opacity: 0, scale: 0.95, y: -8 }}
                            animate={{ opacity: 1, scale: 1, y: 0 }}
                            transition={{ type: "spring", stiffness: 500, damping: 30 }}
                            className="flex items-start gap-3 px-4 py-2.5">
                            <CheckCircleIcon className="mt-0.5 h-5 w-5 flex-shrink-0 text-green-500" />
                            <div className="min-w-0 flex-1">
                                <Link
                                    to={contactPath(item.contactId)}
                                    className="text-sm font-medium leading-tight text-gray-900 hover:underline">
                                    {item.contactName}
                                </Link>
                                <div className="mt-0.5 text-xs text-gray-500">
                                    {describeChannels(item.kinds)}
                                    {item.orgName ? ` · ${item.orgName}` : ""}
                                </div>
                            </div>
                        </motion.li>
                    ))}
                </AnimatePresence>
            </ul>
        </div>
    );
};
